<template>
  <div class="app-container">
    <div class="main-con">
        <div style="margin: 60px 0 0 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;">
          <img
            style="width: 200px;margin-bottom:60px;"
            referrerpolicy="no-referrer"
            src="@/assets/images/fenglin-logo.png"
          />
          <img
              style=" width: 88%;"
              referrerpolicy="no-referrer"
              src="@/assets/images/caigouzhaobiao.png"
              @click="toTenderDoc"
            />
          <img
              style=" width: 88%;   margin-top: 20px;"
              referrerpolicy="no-referrer"
              src="@/assets/images/linyejingpai.png"
              @click="toAuctionItem"
            />
            <img
              style=" width: 88%;   margin-top: 20px;"
              referrerpolicy="no-referrer"
              src="@/assets/images/wuliuzhaobiao.png"
              @click="toLogistics"
            />
        </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { checkLinkPassword } from '@/api/tenderDocument'
import { setCache, clearCache, getCache } from '@/utils/cache'
export default {
  data () {
    return {
      linkPassword: '',
      isAuthorized: false,
      tenderDocumentId: '',
      tenderDocumentTitle: '',
    };
  },
  created () {
    this.tenderDocumentId = this.$route.query.tenderDocumentId
    this.tenderDocumentTitle = this.$route.query.tenderDocumentTitle
  },
  methods: {
    toTenderDoc () {
      this.$router.push('/tenderDoc')
    },
    toAuctionItem () {
      // 如果用户类型为null或undefined或3，则跳转到系统登录页面
      if(getCache('user_type') === null || getCache('user_type') === undefined || getCache('user_type') === 3){
        this.$router.push({ path: '/auctionItem/sysLogin' })
      } else {
        // 如果登录用户的系统类型是1，林业竞拍，开始校验用户类型
        if(getCache('system_type') === 1){
          // 如果用户类型为1，说明是超级管理员
          if(getCache('user_type') === 1){
            this.$router.push({ path: '/auctionItem/user/home' })
          } else if(getCache('user_type') === 2){  // 如果用户类型为2，说明是普通管理员
            this.$router.push({ path: '/auctionItem/home' })
          } else {
            Toast.fail('您无权限访问该页面')
          }
        } else {
          Toast.fail('您无权限访问该页面')
        }
      }
    },
    toLogistics () {
       if(getCache('user_type') === null || getCache('user_type') === undefined || getCache('user_type') === 3){
        this.$router.push({ path: '/logisticsTender/sysLogin' })
      } else {
         // 如果登录用户的系统类型是2，物流招标，开始校验用户类型
        if(getCache('system_type') === 2){
          // 如果用户类型为1，说明是超级管理员
          if(getCache('user_type') === 1){
            this.$router.push({ path: '/logisticsTender/user/home' })
          } else if(getCache('user_type') === 2){  // 如果用户类型为2，说明是普通管理员
            this.$router.push({ path: '/logisticsTender/home' })
          } else {
            Toast.fail('您无权限访问该页面')
          }
        }  else {
            Toast.fail('您无权限访问该页面')
          }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.app-container {
  margin: 0 auto;
  /* 手机端样式 */
  @media screen and (max-width: 768px) {
    width: 100%
  }
  @media screen and (min-width: 769px) {
    width: 1000px;
  }
  .main-con {
    .text-wrapper_1 {
      background-color: rgba(155, 189, 255, 0.93);
      border-radius: 10px;
      padding: 25px 30px 23px 30px;
      width: 76%;
    }
    .text_2 {
      height: 52px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      letter-spacing: 0.3076923191547394px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      text-align: center;
      white-space: nowrap;
      line-height: 56px;
    }
    .image_3 {
      position: absolute;
      width: 160px;
      height: 170px;
      left: 55%;
      top: 235px;
    }
  }
}
</style>
